import { useState } from "react";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

export default function Login() {

  const [email,setEmail] = useState("");
  const [password,setPassword] = useState("");
  const [message,setMessage] = useState("");

  const handleLogin = async (e) => {

    if(e) e.preventDefault();

    setMessage("Logging in...");

    try{

      const response = await fetch(
        API + "/login",
        {
          method:"POST",
          headers:{
            "Content-Type":"application/json"
          },
          body:JSON.stringify({
            email: email.trim().toLowerCase(),
            password: password
          })
        }
      );

      const data = await response.json();

      if(response.ok){

        localStorage.setItem(
          "token",
          data.access_token
        );

        setMessage("Login successful");

        /* REDIRECT DIRECTLY TO TODAY */
        window.location.href="/today";

      }else{

        setMessage("Login failed");

      }

    }catch(err){

      setMessage("Server error");

    }

  };

  return(

    <div className="auth-space">

      <div className="auth-card">

        <h2 className="auth-title">Login</h2>

        <form onSubmit={handleLogin}>

          <input
            className="auth-input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={e=>setEmail(e.target.value)}
            autoCapitalize="none"
            autoCorrect="off"
          />

          <br/>

          <input
            className="auth-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={e=>setPassword(e.target.value)}
          />

          <br/>

          <button
            className="auth-button"
            type="submit"
          >
            Login
          </button>

        </form>

        <p style={{textAlign:"center"}}>{message}</p>

        <p style={{textAlign:"center"}}>
          No account? <a href="/register">Create one</a>
        </p>

      </div>

    </div>

  );

}
